//import _ from 'lodash';
import { FastField, FieldArray, useFormikContext } from 'formik';
import React, { FC } from 'react';
import { Button } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import DateTime from '../../../../../components/library/inputs/dateTime/DateTime';
import NumberInput from '../../../../../components/library/inputs/number/NumberInput';
import Discount from './components/Discount';
import moment from 'moment';

const FixedDatesMode: FC = ({ mode, name }: any) => {
  const intl = useIntl();
  const formikContext = useFormikContext();
  const arrayMeta = formikContext.getFieldMeta(`${name}.installments`);

  return (
    <React.Fragment>
      <div className="section-title">{intl.formatMessage({ id: 'paymentModes.fixedDates' })}</div>
      <div className="my-2">
        {intl.formatMessage(
          { id: 'paymentModes.fixedDatesMode.installmentsCount' },
          { count: mode.installments.length },
        )}
      </div>
      <div>
        <FieldArray
          name={`${name}.installments`}
          render={(arrayHelpers) => {
            return (
              <div>
                {mode.installments.map((installment, index) => {
                  const dateMeta = formikContext.getFieldMeta(`${name}.installments.${index}.date`);
                  const percentMeta = formikContext.getFieldMeta(`${name}.installments.${index}.percent`);
                  return (
                    <div key={index}>
                      <div className="d-flex d-flex-row align-items-center mb-2">
                        <div style={{ maxWidth: 500 }} className="me-2">
                          <FastField name={`${name}.installments.${index}.date`}>
                            {({ field, form }) => {
                              form.setFieldValue(
                                field.name,
                                field.value ? moment(field.value).format('YYYY-MM-DD') : field.value,
                              );

                              return (
                                <div>
                                  <DateTime
                                    placeholder="Date"
                                    mode={'date'}
                                    onChange={(value) => {
                                      form.setFieldValue(field.name, value);
                                    }}
                                    value={field.value || undefined}
                                    enabled={true}
                                  ></DateTime>
                                </div>
                              );
                            }}
                          </FastField>
                        </div>
                        <div style={{ width: 70 }} className="me-2">
                          <FastField name={`${name}.installments.${index}.percent`}>
                            {({ field, form }) => {
                              return (
                                <div>
                                  <NumberInput
                                    enabled={true}
                                    placeholder="%"
                                    onChange={(event) => {
                                      form.setFieldValue(field.name, event.target.value);
                                      formikContext.validateField(`${name}.installments`);
                                    }}
                                    value={field.value}
                                    minValue={0}
                                    maxValue={100}
                                  ></NumberInput>
                                </div>
                              );
                            }}
                          </FastField>
                        </div>
                        <Button
                          variant="danger"
                          onClick={() => {
                            arrayHelpers.remove(index);
                          }}
                        >
                          x
                        </Button>
                      </div>

                      {((dateMeta.touched && dateMeta.error) || (percentMeta.touched && percentMeta.error)) && (
                        <div className="feedback-invalid mb-2">{dateMeta.error || percentMeta.error}</div>
                      )}
                    </div>
                  );
                })}

                {arrayMeta.touched && arrayMeta.error && typeof arrayMeta.error === 'string' && (
                  <div className="mb-2 feedback-invalid">{arrayMeta.error}</div>
                )}
                <Button
                  onClick={() => {
                    arrayHelpers.push({ date: null, percent: 0 });
                  }}
                >
                  +
                </Button>
              </div>
            );
          }}
        ></FieldArray>
      </div>
      <div className="mt-2">
        <Discount name={`${name}.discount`} discount={mode.discount}></Discount>
      </div>
    </React.Fragment>
  );
};

export default FixedDatesMode;
